import { type ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';

import Button from 'components/Button';
import Input from 'components/Input';
import PopUp from 'components/PopUp';
import { emojiRegex } from 'global/constants';
import closeIcon from 'static/ic-close-black.svg';
import { authLoginEmailRequest } from 'store/auth/authActions';
import { CloseIcon } from 'views/GetInPopUp/styled';

import { ButtonsContainer, SecondInput } from './styled';
import { getValidationScheme } from './validation';

interface EmailAuthProps {
  closeModal: () => void;
}
interface FormValues {
  modalEmail: string;
  password: string;
}

const EmailAuthModal = ({ closeModal }: EmailAuthProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(getValidationScheme()),
  });
  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => e.target.value.replace(emojiRegex, '').substring(0, 30);
  const handleLogin: SubmitHandler<FormValues> = ({ modalEmail, password }) => {
    dispatch(authLoginEmailRequest({
      email: modalEmail, password, closeModal,
    }));
    reset({ modalEmail: '' });
  };

  return (
    <PopUp text={t('auth.emailLogin')}>
      <CloseIcon src={closeIcon} onClick={closeModal} />
      <Input
        key="modal-input-email"
        data-test-id="email_input"
        id="modal-email"
        type="email"
        label={t('auth.email')}
        placeholder={t('auth.email')}
        register={register}
        name="modalEmail"
        errors={errors}
        onChange={onInputChange}
        control={control}
      />
      <SecondInput
        data-test-id="password_input"
        id="password"
        label={t('auth.password')}
        placeholder={t('auth.password')}
        register={register}
        name="password"
        errors={errors}
        onChange={onInputChange}
        type="password"
        control={control}
      />
      <ButtonsContainer>
        <Button data-test-id="email_login" background="black" onClick={handleSubmit(handleLogin)}>{t('settings.login')}</Button>
        <Button background="black" onClick={closeModal}>{t('common.close')}</Button>
      </ButtonsContainer>
    </PopUp>
  );
};

export default EmailAuthModal;
